var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":""}},[_c('v-container',{staticClass:"py-0 fill-height align-center"},[_c('v-toolbar-title',[_vm._v("بےبی سٹورم")]),_c('v-spacer'),_c('v-toolbar-items',[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.$emit('toggleTheme')}}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.getLogo)+" ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }